import React from 'react'
import PropTypes from 'prop-types'
import { useQuery } from '@apollo/client'
import { withTranslation } from 'react-i18next'
import { Card, Spin, Alert } from 'antd'
import { GET_SHIPPING_PERIOD_BASED_ON_PAYMENT_TIME } from '../../graphql/shippingPeriodBasedOnPaymentTime'

const ShippingPeriodBasedOnPaymentTime = ({ orderNumber, i18n }) => {
  const { data, loading, error } = useQuery(
    GET_SHIPPING_PERIOD_BASED_ON_PAYMENT_TIME,
    {
      variables: { orderNumber }
    }
  )

  if (error || loading) { return <Spin /> }

  const { order } = data || {}

  const paymentTime = order.paymentTime && data.order.paymentTime.display
  const processingTime = order && order.shippingPeriodBasedOnPaymentTime && order.shippingPeriodBasedOnPaymentTime.processingTime

  return (
    <div
      className='order-shipping-period-based-on-payment-time-container'
      style={{ padding: '8px 0' }}
    >
      <span style={{ fontWeight: 'bold' }}>
        {i18n.t('inquiries:shippingPeriodBasedOnPaymentTime')} ({paymentTime || '-'}) :
      </span>
      {paymentTime ? (
        <span> {processingTime || '-'} </span>
      ) : (
        <Alert
          message={i18n.t('inquiries:waitingPayment')}
          type="warning"
          showIcon
        />
      )}
    </div>
  )
}

ShippingPeriodBasedOnPaymentTime.propTypes = {
  orderNumber: PropTypes.string.isRequired,
  i18n: PropTypes.object.isRequired
}

export default withTranslation('inquiries')(ShippingPeriodBasedOnPaymentTime)
